import { Stack, Typography } from "@mui/material";
import ReservationDateRange from "../../text/ReservationDateRange";
import WushPopover from "../../layout/WushPopover";
import OrderSummary from "../orders/OrderSummary";
import { useEffect, useState } from "react";

export default function ReservationSlot({ reservation }) {
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (reservation?.order_id) {
      setOrder(reservation.order);
    }
    return (() => {
      setOrder(null);
    });
  }, [reservation.order_id]);

  return (
      <WushPopover
        key={reservation.id}
        anchor={
          <Stack>
            <Stack direction="row" gap={0.5}>
              <Typography variant="body1" fontWeight="700">
                {reservation?.order?.customer?.first_name} {reservation?.order?.customer?.last_name}
              </Typography>
              {reservation?.admin_comments && <Typography variant="body1" fontWeight="400">
                {reservation?.admin_comments}
              </Typography>}
            </Stack>
            <ReservationDateRange reservation={reservation} fontWeight="400" />
          </Stack>
        }
      >
        <Stack p={2}>
          <OrderSummary order={order} forceReservations={[reservation]} />
        </Stack>
      </WushPopover>
  );
}